import React, { useEffect, useMemo, useState } from "react";

import Image from "../../images/user-avatar-80.png";
import { useDispatch, useSelector } from "react-redux";
import { formatPhoneNumber } from "../../utils/Utils.js";
import ToggleSwitch from "../../components/ToggleSwitch.jsx";
import config from '@/config';
import { addToast } from "../../store/app/action.js";
import {DangerButton, PrimaryButton, SecondaryButton} from "../../components/Buttons.jsx";

function StorePanel() {
  const [sync, setSync] = useState(false);
  const dispatch = useDispatch();
  const { selectedLocation } = useSelector((state) => state.app);
  if (!selectedLocation) return null;
  return (
    <div className="grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-5">
          Online Store Settings - {selectedLocation.name}
        </h2>
        {/* Picture */}
        <section>
          <h2 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold mb-1">
            Store Logo
          </h2>
          <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-5">
            <div className="mr-4">
              <img
                className="w-20 h-20 rounded-full"
                src={Image}
                width="80"
                height="80"
                alt="User upload"
              />
            </div>
            <button className="btn-sm bg-indigo-500 hover:bg-indigo-600 text-white">
              Change
            </button>
          </div>
        </section>
        <section>
          <h2 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold mb-1">
            Header Image
          </h2>
          <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-5">
            <div className="mr-4">
              <img
                className="w-80 h-40"
                src={Image}
                width="160"
                height="80"
                alt="User upload"
              />
            </div>
            <DangerButton size={'sm'}>
              Remove
            </DangerButton>
            <button className="btn-sm bg-indigo-500 hover:bg-indigo-600 text-white">
              Change
            </button>

          </div>
        </section>



      </div>
      {/* Panel footer */}
      <footer>
        <div className="flex flex-col px-6 py-5 border-t border-slate-200 dark:border-slate-700">
          <div className="flex self-end">
            <button
              className="btn dark:bg-theme-surface-accent border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300">
              Cancel
            </button>
            <button className="btn bg-indigo-500 hover:bg-indigo-600 text-white ml-3">
              Save Changes
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default StorePanel;
